import { useDispatch, useSelector } from 'react-redux';

import * as baseDealActionCreators from '@makemydeal/dr-dash-store/actions/baseDealActionCreators';
import * as interactionAnalyticsActionCreators from '@makemydeal/dr-dash-store/actions/interactionAnalyticsActionCreators';
import * as programsSelectors from '@makemydeal/dr-dash-store/selectors/programsSelectors';

export const useAutoSelectedLenderProgramBanner = () => {
    const dispatch = useDispatch();
    const isAutoSelected = useSelector(programsSelectors.getIsLenderProgramAutoSelected);

    const openProgramsAndIncentives = (): void => {
        dispatch(interactionAnalyticsActionCreators.mvIncentivesLink());
        dispatch(baseDealActionCreators.openSlideOut(baseDealActionCreators.SlideOutType.Incentives));
    };

    return { isAutoSelected, openProgramsAndIncentives };
};
